import React from 'react';
import { contactPanelStyle } from './CampaignBriefStyles';
import { sectionedPanelStyle } from '../CampaignStyles';
import CampaignSalesExec from './CampaignManagement/CampaignSalesExec';
import CampaignPlanner from './CampaignManagement/CampaignPlanner';
import CampaignActivationOwner from './CampaignManagement/CampaignActivationOwner';
import CampaignSalesTeam from './CampaignManagement/CampaignSalesTeam';

const CampaignManagement = ({ campaign, onCampaignManagementChange, readOnly, editAuthorisedOnly }) => {

    const handleChangeSalesExec = (salesExecId, salesExecName, salesTeamId) => {
        onCampaignManagementChange('salesExecName',salesExecName);
        onCampaignManagementChange('salesExecId', salesExecId)
        onCampaignManagementChange('salesTeamId', salesTeamId)
    };

    const handleChangePlanner = (plannerName, plannerId) => {
        onCampaignManagementChange('plannerName', plannerName);
        onCampaignManagementChange('plannerId', plannerId);
    };

    const handleChangeActivationOwner = (activationOwnerName, activationOwnerId) => {
        onCampaignManagementChange('campaignOwnerName', activationOwnerName);
        onCampaignManagementChange('campaignOwnerId', activationOwnerId);
    };

    const handleChangeSalesTeamId = (salesTeamId) => {
        onCampaignManagementChange('salesTeamId', salesTeamId)
    }

    return (
        <div style={sectionedPanelStyle}>
            <div
                style={{
                    ...contactPanelStyle,
                    paddingRight: 19,
                    paddingBottom: 8
                }}
            >
                <span style={{ fontSize: 15, fontWeight: 500, marginBottom: 17 }}>
                    {window.translate('Campaign Management')}
                </span>
            </div>
            <div
                style={{
                    ...contactPanelStyle,
                    paddingTop: 0,
                    flexDirection: 'column'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginBottom: 18
                    }}
                >
                    <CampaignSalesExec
                        campaign={campaign}
                        onChange={handleChangeSalesExec}
                        readOnly={readOnly}
                    />
                    <CampaignPlanner
                        campaign={campaign}
                        onChange={handleChangePlanner}
                        readOnly={readOnly}
                    />
                    <CampaignActivationOwner
                        campaign={campaign}
                        onChange={handleChangeActivationOwner}
                        readOnly={readOnly}
                    />
                    <CampaignSalesTeam
                        campaign={campaign}
                        onChange={handleChangeSalesTeamId}
                        readOnly={readOnly}
                        editAuthorisedOnly={editAuthorisedOnly}
                    />
                </div>
            </div>
        </div>
    );
};

export default CampaignManagement;
